import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { loggMeIN, rmAuth, toggleMenu } from "../../redux/Functions/actions";
import {
  MenuButton,
  PageStyle,
  PageTitleStyle,
  TableResponsive,
  TableBody,
  TableHead,
  TableRowHead,
  TableRowBody,
  PageContainer,
  Table,
  TableHeadStyle,
  TableBodyStyle,
  EyeIcon,
  Pagination
} from "../../styles/MainLayout";
import UsersModal from "./usersModal";
import Search from "../search/search";
import { Link } from "react-router-dom";
import axios from "../../axios"
import ReactPaginate from "react-paginate";


const Users = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [users, setUsers] = useState();
  const [usersData, setUsersData] = useState();
  const [filtered, setFiltered] = useState([]);

  // Pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 8;
  const pagesVisited = pageNumber * productsPerPage;
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  }
  const getUsers = () => {
    axios.get('/users/all').then(data => {
      setUsers(data.data);
      setFiltered(data?.data);

    }).catch(err => {
      console.log(err)
    })
  }

  useEffect(()=>{
    getUsers();
  },[])


  const handleModalAdd = () => {
    setModalType("add");
    setIsOpen(true);
  };

  const handleModalEdit = (data) => {
    setUsersData(data)
    setModalType("edit");
    setIsOpen(true);
  };

  const handleMenuClick = (e) => {
    e.prevenTableHeadStyleefault();
    props.toggleMenu();
  };

  return (
    <>
    {isOpen === true ?
      <UsersModal
        user={usersData}
        isOpen={isOpen}
        type={modalType}
        handleModalClose={() => { setIsOpen(false); setUsersData(null) }}
        getData={() => getUsers()}
      />
      : ""
      }

      <PageStyle isMenuOpen={props?.menu}>
        <PageTitleStyle>Users</PageTitleStyle>
        <Search data={users} filtered={setFiltered} setPageNumber={setPageNumber}/>
        <MenuButton onClick={handleMenuClick}>
          {props.menu ? (
            <i className="fa fa-chevron-left"></i>
          ) : (
            <i className="fa fa-bars"></i>
          )}
        </MenuButton>

        <PageContainer>
          <TableResponsive isMenuOpen={props?.menu}>
            <Table>
              <TableHead>
                <TableRowHead>
                  <TableHeadStyle tableFirstElement>ID</TableHeadStyle>
                  <TableHeadStyle>First Name</TableHeadStyle>
                  <TableHeadStyle>Last Name</TableHeadStyle>
                  <TableHeadStyle>Email</TableHeadStyle>
                  <TableHeadStyle>Actions</TableHeadStyle>
                </TableRowHead>
              </TableHead>
              <TableBody>
              {filtered && filtered?.length === 0 && <div className='text-secondary text  m-3'><h6>Nuk ka të dhëna</h6></div>}
                {filtered && filtered?.length > 0 && <>
                  {filtered?.slice(pagesVisited, pagesVisited + productsPerPage)?.map((el, index) => {
                    return (
                      <>

                        <TableRowBody>
                          <TableBodyStyle tableFirstElement>{el?.id}</TableBodyStyle>
                          <TableBodyStyle >{el?.first_name}</TableBodyStyle>
                          <TableBodyStyle>{el?.last_name}</TableBodyStyle>
                          <TableBodyStyle>{el?.email}</TableBodyStyle>
                          <TableBodyStyle>
                            <EyeIcon onClick={() => handleModalEdit(el)}/>
                            <Link to={`/settings/user-info/${el?.id}`} className="ms-5">
                              <i className="fa fa-user" title="User Info"></i>
                            </Link>
                          </TableBodyStyle>
                        </TableRowBody>
                        </>
                    )
                  })}</>
                }
  
              </TableBody>
            </Table>
            <Pagination>
              <div className="text-right">
                {((users?.length >= productsPerPage) ?
                  <ReactPaginate
                    previousLabel={<i className='fa fa-angle-double-left' />}
                    nextLabel={<i className='fa fa-angle-double-right' />}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={"paginationBttns"}
                    previousLinkClassName={"previousBttn"}
                    nextLinkClassName={"nextBttn"}
                    disabledClassName={"paginationDisabled"}
                    activeClassName={"paginationActive"}
                  /> : ''
                )}
              </div>
            </Pagination>
          </TableResponsive>
        </PageContainer>
      </PageStyle>

      <MenuButton
        add
        onClick={() => {
          handleModalAdd();
        }}
      >
        <i className="fa fa-plus" />
      </MenuButton>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    lang: state.data.lang,
    langData: state.data.langData,
    isLoading: state.data.isLoading,
    loggedIn: state.data.loggedIn,
    menu: state.data.menu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loggMeIN: () => dispatch(loggMeIN()),
    rmAuth: () => dispatch(rmAuth()),
    toggleMenu: () => dispatch(toggleMenu()),
    // loadingOff: () => dispatch(loadingOff()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Users);
